import React from 'react';
import { Box, Typography } from '@mui/material';
import { Button } from 'framework/ui/mui-builder';
import { TextArea, DateInput, useFormContext } from 'framework/form';
import { useDateService } from 'framework/utils';

interface FollowUpFormContentProps {
  onClose: () => void;
  isUpdateMode: boolean;
}

const FollowUpFormContent: React.FC<FollowUpFormContentProps> = ({ onClose, isUpdateMode }) => {
  const { getToday } = useDateService();
  const { submitForm, isSubmitEnabled } = useFormContext();

  return (
    <Box>
      <Typography variant="h3" mb={2}>
        {isUpdateMode ? 'Update follow-up' : 'Add follow-up'}
      </Typography>

      <Box sx={{ mb: 2 }}>
        <TextArea source="description" label="Description" placeholder="Enter follow-up description" />
      </Box>

      <Box sx={{ mb: 2 }}>
        <DateInput source="followUpDate" label="Follow-up date" minDate={getToday()} />
      </Box>

      <Box sx={{ display: 'flex', gap: 2, justifyContent: 'flex-end', mt: 3 }}>
        <Button variant="outlined" onClick={onClose}>
          Cancel
        </Button>
        <Button variant="contained" onClick={submitForm} disabled={!isSubmitEnabled}>
          {isUpdateMode ? 'Update' : 'Add'}
        </Button>
      </Box>
    </Box>
  );
};

export default FollowUpFormContent;
